import Vue from 'vue';
import Vuex from 'vuex';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    // systemParameters: null,
    // studentList:[],
    erp_api_url: "https://learn360.frappe.cloud/",
    authorization_token:"token 24dfd82ad8cfdbd:c5586bd491bd8ef"
  },
  mutations: {
    // setSystemParameters(state, parameters) {
    //   state.systemParameters = parameters;
    // },
  },
  // actions: {
  //   fetchSystemParameters({ commit }) {
  //     return new Promise((resolve, reject) => {
  //       try {
  //         fetch('https://localhost:44387/systemParameters')
  //           .then(response => {
  //             if (!response.ok) {
  //               throw new Error('Network response was not ok');
  //             }
  //             return response.json();
  //           })
  //           .then(data => {
  //             commit('setSystemParameters', data);
  //             resolve(data);
  //           })
  //           .catch(error => {
  //             console.error('Error fetching system parameters:', error);
  //             reject(error);
  //           });
  //       } catch (error) {
  //         console.error('Error fetching system parameters:', error);
  //         reject(error);
  //       }
  //     });
  //   },
  //   getStudentList({ commit },{searchString}) {
  //     console.log(searchString);
  //     var url=`https://localhost:44387/students?`;
  //     if(searchString){
  //       url+=`searchString=${searchString}&`
  //     }
  //     // if(lastId){
  //     //   url+=`lastId=${lastId}`
  //     // }
  //     return new Promise((resolve, reject) => {
  //       try {
  //         fetch(url)
  //           .then(response => {
  //             if (!response.ok) {
  //               throw new Error('Network response was not ok');
  //             }
  //             return response.json();
  //           })
  //           .then(data => {
  //             this.state.studentList = data.payload.responseData;
  //             resolve(data);
  //           })
  //           .catch(error => {
  //             console.error('Error fetching system parameters:', error);
  //             reject(error);
  //           });
  //       } catch (error) {
  //         console.error('Error fetching system parameters:', error);
  //         reject(error);
  //       }
  //     });
  //   },
  // },
});

export default store;
